//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Draggable from 'vuedraggable';
import i18n from '@/utils/i18n';
import CodeEditor from '@/components/code-editor/index';
export default {
  name: 'OptionItemsSetting',
  mixins: [i18n],
  components: {
    Draggable: Draggable,
    CodeEditor: CodeEditor
  },
  props: {
    designer: Object,
    selectedWidget: Object
  },
  data: function data() {
    return {
      showImportDialogFlag: false,
      optionLines: '',
      cascaderOptions: '',
      showImportCascaderDialogFlag: false,
      //separator: '||',
      separator: ','
    };
  },
  computed: {
    optionModel: function optionModel() {
      return this.selectedWidget.options;
    }
  },
  watch: {
    'selectedWidget.options': {
      deep: true,
      handler: function handler(val) {
        //console.log('888888', 'Options change!')
      }
    }
  },
  methods: {
    emitDefaultValueChange: function emitDefaultValueChange() {
      if (!!this.designer && !!this.designer.formWidget) {
        var fieldWidget = this.designer.formWidget.getWidgetRef(this.selectedWidget.options.name);
        if (!!fieldWidget && !!fieldWidget.refreshDefaultValue) {
          fieldWidget.refreshDefaultValue();
        }
      }
    },
    deleteOption: function deleteOption(option, index) {
      this.optionModel.optionItems.splice(index, 1);
    },
    addOption: function addOption() {
      var newValue = this.optionModel.optionItems.length + 1;
      this.optionModel.optionItems.push({
        value: newValue,
        label: 'new option'
      });
    },
    importOptions: function importOptions() {
      var _this = this;
      this.optionLines = '';
      if (this.optionModel.optionItems.length > 0) {
        this.optionModel.optionItems.forEach(function (opt) {
          if (opt.value === opt.label) {
            _this.optionLines += opt.value + '\n';
          } else {
            _this.optionLines += opt.value + _this.separator + opt.label + '\n';
          }
        });
      }
      this.showImportDialogFlag = true;
    },
    saveOptions: function saveOptions() {
      var _this2 = this;
      var lineArray = this.optionLines.split('\n');
      //console.log('test', lineArray)
      if (lineArray.length > 0) {
        this.optionModel.optionItems = [];
        lineArray.forEach(function (optLine) {
          if (!!optLine && !!optLine.trim()) {
            if (optLine.indexOf(_this2.separator) !== -1) {
              _this2.optionModel.optionItems.push({
                value: optLine.split(_this2.separator)[0],
                label: optLine.split(_this2.separator)[1]
              });
            } else {
              _this2.optionModel.optionItems.push({
                value: optLine,
                label: optLine
              });
            }
          }
        });
      } else {
        this.optionModel.optionItems = [];
      }
      this.showImportDialogFlag = false;
    },
    resetDefault: function resetDefault() {
      if (this.selectedWidget.type === 'checkbox' || this.selectedWidget.type === 'select' && this.selectedWidget.options.multiple) {
        this.optionModel.defaultValue = [];
      } else {
        this.optionModel.defaultValue = '';
      }
      this.emitDefaultValueChange();
    },
    importCascaderOptions: function importCascaderOptions() {
      this.cascaderOptions = JSON.stringify(this.optionModel.optionItems, null, '  ');
      this.showImportCascaderDialogFlag = true;
    },
    saveCascaderOptions: function saveCascaderOptions() {
      try {
        var newOptions = JSON.parse(this.cascaderOptions);
        this.optionModel.optionItems = newOptions;
        //TODO: 是否需要重置选项默认值？？

        this.showImportCascaderDialogFlag = false;
      } catch (ex) {
        this.$message.error(this.i18nt('designer.hint.invalidOptionsData') + ex.message);
      }
    }
  }
};